import { ActionForbidden, CopyingToClipboardForbidden, DataMismatch, InvalidInputData, NotFound } from './common';
import {
  ConversionMolToSmilesError,
  ConversionMolfileToMolError,
  ConversionReactionToRxnError,
  ConversionSmilesToMolError,
} from './conversion';
import InternalError from './internal-error';
import { MolfileParsingError } from './parsing';
import { typeMap as errorTypeMap } from './type-map';

const errorMap = {
  [errorTypeMap.internal]: InternalError,
  [errorTypeMap.common.invalidInputData]: InvalidInputData,
  [errorTypeMap.common.dataMismatch]: DataMismatch,
  [errorTypeMap.common.actionForbidden]: ActionForbidden,
  [errorTypeMap.common.notFound]: NotFound,
  [errorTypeMap.common.copyingToClipboardForbidden]: CopyingToClipboardForbidden,
  [errorTypeMap.conversion.smilesToMol]: ConversionSmilesToMolError,
  [errorTypeMap.conversion.molfileToMol]: ConversionMolfileToMolError,
  [errorTypeMap.conversion.molToSmiles]: ConversionMolToSmilesError,
  [errorTypeMap.conversion.reactionToRxn]: ConversionReactionToRxnError,
  [errorTypeMap.parsing.molfile.general]: MolfileParsingError,
};

export function buildError(type, payload) {
  const ErrorConstructor = errorMap[type] || InternalError;
  return new ErrorConstructor(payload);
}

export function isMolviewError(error) {
  return Object.values(errorMap).some(ErrorConstructor => error instanceof ErrorConstructor);
}
